var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['IconButton'],attrs:{"title":_vm.text}},[_c('div',{class:['IconButton__icon', ("IconButton__icon--" + _vm.icon)]}),(_vm.text)?_c('div',{staticClass:"IconButton__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }